import { Flex } from '@mantine/core';
import * as React from 'react';
import { matchPath, Outlet, useLocation } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';
import NoteContent from '@/layouts/OrganizationLayout/NoteContent';
import { useDevices } from '@/utils/devices';

import s from './OrganizationNoteLayout.module.scss';

const OrganizationNoteLayout: React.FC = () => {
  const { pathname } = useLocation();
  const { isCompactViewport } = useDevices();

  const showList =
    isCompactViewport &&
    (Boolean(matchPath({ path: ROUTES.organization.notebook.notes.path, end: true }, pathname)) ||
      Boolean(matchPath({ path: ROUTES.organization.notebook.followUps.path, end: true }, pathname)) ||
      Boolean(matchPath({ path: ROUTES.organization.notebook.insights.path, end: true }, pathname)));

  return (
    <Flex direction="column" className={s.root}>
      {showList ? <NoteContent /> : <Outlet />}
    </Flex>
  );
};

export default OrganizationNoteLayout;
